import { getFlexUtility, getSafeFlexProps } from '../Flex/Flex.utils';
import { getClasses } from '@/_utils/classnames';
import type { ColumnProps } from './Column.types';
import type { FC } from 'react';

export const Column: FC<ColumnProps> = (props) => {
  const mainFlexClasses = getFlexUtility({ ...props, isColumn: true });
  const columnClasses: string = getClasses(mainFlexClasses, {
    'flex-x-center': props.isColumnCentered,
  });

  const safeProps = getSafeFlexProps(props);
  const columnStyle = {
    maxWidth: '100%',
    width: `${props.width ?? 440}px`,
  };

  return <div {...safeProps} style={columnStyle} className={columnClasses} />;
};
